<template>
    <div>
        <AdoptionNavbar v-if="customerInfo">
            <template #header>
                Adoption Status for {{customerInfo.schoolname}}
            </template>
        </AdoptionNavbar>


        <section class="pt-5 mt-5 mt-md-3 row">
            <div class="col-2 pl-5 w-100">
                <AdoptionLeftNav/>
            </div>

            <div class="col-lg-10">
                <b-container>
                    <div v-if="isLoading">
                        <content-placeholders>
                            <content-placeholders-text :lines="10" />
                        </content-placeholders>
                    </div>
                    <router-view v-else-if="seriesId" />

                    <div v-else>
                        <b-alert show variant="danger">
                            <h4 class="alert-heading">Error!</h4>
                            <p>
                                There was an error fetching the data. Please try again later or contact our customer support team.
                                <br/><br/>
                                adoptionsupport@studiesweekly.com<br/>
                                (866) 311-8734 ext.2
                            </p>
                        </b-alert>
                    </div>
                </b-container>
            </div>
        </section>
        <zendesk-widget-button/>
    </div>
</template>

<script>
import AdoptionNavbar from "@/components/adoptions/AdoptionNavbar";
import {mapState} from "vuex";
import AdoptionLeftNav from "@/components/adoptions/AdoptionLeftNav";
import ZendeskWidgetButton from "@/components/ZendeskWidgetButton.vue";
export default {
    name: "Index",
    components: {ZendeskWidgetButton, AdoptionLeftNav, AdoptionNavbar},
    props: ['customerId'],
    computed: {
        ...mapState({
            seriesId: state => state.adoption.seriesId,
            customerInfo: state => state.adoption.adoptionData.data.misc
        })
    },
    data: () => ({
        isLoading: false,
    }),
    created() {
        this.isLoading = true;
        this.$store.dispatch("getAdoptionData", this.customerId)
            .then(data => {
            })
            .catch((err) => {
                console.log('store_cust_id', this.$store.getters.adoptionCustomerId);
                if (this.$store.getters.adoptionCustomerId != this.customerId) {
                    this.$store.commit('resetAdoptions')
                }
            })
            .finally(() => {
                this.isLoading = false;
            })
    }
}
</script>

<style scoped>

</style>